<div class="auth-wrapper">
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'verifyEmailError.headline' | transloco }}</h1>

      @if (!submitted) {
        <p class="supporting">{{ 'verifyEmailError.supporting' | transloco }}</p>
        <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
          <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <mat-label>{{ 'common.form.emailLabel' | transloco }}</mat-label>
            <input matInput type="email" formControlName="email" maxlength="254" autocomplete="email"/>
            @if (form.get('email')?.hasError('required') && form.get('email')?.touched) {
              <mat-error>{{ 'common.errors.emailRequired' | transloco }}</mat-error>
            }
            @if (form.get('email')?.hasError('email') && form.get('email')?.touched) {
              <mat-error>{{ 'common.errors.emailInvalid' | transloco }}</mat-error>
            }
          </mat-form-field>

          <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || loading">
            {{ 'verifyEmailError.requestNewLink' | transloco }}
          </button>

          <div class="login-link">
            <a [routerLink]="['/']" queryParamsHandling="preserve">{{ 'common.backToSignIn' | transloco }}</a>
          </div>
        </form>
      } @else {
        <p class="confirmation">{{ 'verifyEmailError.confirmation' | transloco }}</p>
        <div class="login-link">
          <a [routerLink]="['/']" queryParamsHandling="preserve">{{ 'common.backToSignIn' | transloco }}</a>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
